<template>
  <div :class="{ 'condition-group': !group?.first }" v-if="group !== undefined">
    <div class="group-head">
      <label>{{ group?.first ? "Visible if" : "and inside this group" }}</label>
      <select v-model="group.operator">
        <option value="AND">all of these are true</option>
        <option value="OR">any of these is true</option>
      </select>
    </div>
    <div
      v-for="(item, index) in group.conditions"
      :key="index"
      class="condition-item"
    >
      <condition-editor
        v-if="item.type === 'condition'"
        v-model="group.conditions[index]"
        :variables="variables"
        :categories="categories"
      />
      <condition-group-editor
        v-else
        v-model="group.conditions[index]"
        :variables="variables"
        :categories="categories"
      />
      <button class="rule-remove" @click="removeCondition(index)">
        Remove this rule
      </button>
    </div>

    <div class="group-actions">
      <button class="text-btn" @click="addCondition">+ Add rule</button>
      <button class="text-btn" @click="addGroup">+ Add group</button>
    </div>
  </div>
</template>

<script>
import ConditionEditor from "./ConditionEditor.vue";
import ConditionGroupEditor from "./ConditionGroupEditor.vue";

export default {
  name: "ConditionGroupEditor",
  components: { ConditionEditor, ConditionGroupEditor },
  props: {
    variables: { type: Array, default: () => [] },
    categories: { type: Array, default: () => [] },
    modelValue: { type: Object, default: undefined },
  },
  emits: ["update:modelValue"],
  computed: {
    group: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.$emit("update:modelValue", {
            type: "group",
            first: true,
            operator: "AND",
            conditions: [],
          });
        }
      },
    },
  },
  methods: {
    addCondition() {
      this.group.conditions.push({
        type: "condition",
        variable: "",
        operator: "==",
        value: "",
      });
    },
    addGroup() {
      this.group.conditions.push({
        type: "group",
        operator: "AND",
        conditions: [
          {
            type: "condition",
            variable: "",
            operator: "==",
            value: "",
          },
        ],
      });
    },
    removeCondition(index) {
      this.group.conditions.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.group-head {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}
.group-head label {
  font-size: 11px;
  font-weight: 700;
  color: #768692;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  flex: none;
}
.group-head select {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 6px 8px;
  font-size: 12px;
  font-weight: 700;
  background: #fff;
  flex: 1;
  min-width: 0;
}
.condition-item {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px;
  margin-bottom: 8px;
  background: #fff;
}
.rule-remove {
  border: none;
  background: transparent;
  color: #d22f0b;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 0 0 0;
  cursor: pointer;
}
.rule-remove:hover {
  text-decoration: underline;
}
.group-actions {
  display: flex;
  gap: 12px;
}
</style>
